// extracted by mini-css-extract-plugin
module.exports = {"block":"Nil100Widget_block__8k_LP","links":"Nil100Widget_links__nCh_x","list":"Nil100Widget_list__ueGOu","logo":"Nil100Widget_logo__WYfT7","nilLogo":"Nil100Widget_nilLogo__hH_q6"};